import { render, staticRenderFns } from "./RecipeAttachments.vue?vue&type=template&id=f1d3a854"
import script from "./RecipeAttachments.vue?vue&type=script&lang=js"
export * from "./RecipeAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports